import { API_BASE_URLS, LS_KEYS, EMAIL_API_KEY } from "./constants";
import {
  apiOwner,
  getCurrentOwnersLocaleSelector,
  getCurrentUserEmail,
} from "../../../utils/apis";

function getFunctionsBase() {
  try {
    const env = (localStorage.getItem(LS_KEYS.env) ||
      "dev") as keyof typeof API_BASE_URLS;
    return API_BASE_URLS[env] || API_BASE_URLS.dev;
  } catch (e) {
    return API_BASE_URLS.dev;
  }
}

function trimTrailingSlashes(s: string) {
  if (!s) return s;
  let end = s.length;
  while (end > 0 && s[end - 1] === "/") end -= 1;
  return s.substring(0, end);
}

export async function listAuditEntries(params?: Record<string, any>) {
  const base = getFunctionsBase();
  const url = `${trimTrailingSlashes(base)}/audit-log-rc`;
  const headers = {
    "Content-Type": "application/json",
    "X-Kinship-Source": "Kinship",
    emailApiKey: `${EMAIL_API_KEY}`,
    "Accept-Language": getCurrentOwnersLocaleSelector(),
    "X-KI-Requester-Email": getCurrentUserEmail(),
  };
  return await apiOwner.get(url, { params, headers });
}

export async function getAuditEntry(id: string) {
  const base = getFunctionsBase();
  const url = `${trimTrailingSlashes(base)}/audit-log-rc/${id}`;
  const headers = {
    "Content-Type": "application/json",
    "X-Kinship-Source": "Kinship",
    emailApiKey: `${EMAIL_API_KEY}`,
    "Accept-Language": getCurrentOwnersLocaleSelector(),
    "X-KI-Requester-Email": getCurrentUserEmail(),
  };
  return await apiOwner.get(url, { headers });
}

export async function getAuditStats(params?: Record<string, any>) {
  const base = getFunctionsBase();
  const url = `${trimTrailingSlashes(base)}/audit-log-rc/stats`;
  const headers = {
    "Content-Type": "application/json",
    "X-Kinship-Source": "Kinship",
    emailApiKey: `${EMAIL_API_KEY}`,
    "Accept-Language": getCurrentOwnersLocaleSelector(),
    "X-KI-Requester-Email": getCurrentUserEmail(),
  };
  return await apiOwner.get(url, { params, headers });
}
